'use strict';

var React = require('react');

const useWindowResize = ({ listener }) => {
    React.useEffect(() => {
        globalThis.addEventListener('resize', listener);
        return () => globalThis.removeEventListener('resize', listener);
    }, [listener]);
};

exports.useWindowResize = useWindowResize;
//# sourceMappingURL=useWindowResize.js.map
